var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.16602 18.3334L7.93399 16.3718C7.07586 15.0055 6.64678 14.3223 5.96646 14.1995C4.85895 13.9995 3.7143 14.7538 2.91602 15.4242",
    stroke: "#3F3F3F",
    strokeWidth: 1.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.91602 7.5V13.3566C2.91602 14.3589 2.91602 14.8601 3.16493 15.2628C3.41385 15.6656 3.86211 15.8898 4.75864 16.338L8.04553 17.9814C8.74618 18.3317 8.75293 18.3333 9.53627 18.3333H12.0827C14.4397 18.3333 15.6182 18.3333 16.3504 17.6011C17.0827 16.8688 17.0827 15.6903 17.0827 13.3333V7.5C17.0827 5.14297 17.0827 3.96447 16.3504 3.23223C15.6182 2.5 14.4397 2.5 12.0827 2.5H7.91602C5.55899 2.5 4.38048 2.5 3.64825 3.23223C2.91602 3.96447 2.91602 5.14297 2.91602 7.5Z",
    stroke: "#3F3F3F",
    strokeWidth: 1.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 7.5H6.66602M13.3327 11.6667H6.66602",
    stroke: "#3F3F3F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1673 1.66675V3.33341M10.0007 1.66675V3.33341M5.83398 1.66675V3.33341",
    stroke: "#3F3F3F",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.6b660accb19ed0eb14ed95313219cbd2.svg";
export { ForwardRef as ReactComponent };